import { inject, Injectable } from "@angular/core";
import { UsersService } from "./users.service";
import { toSignal } from "@angular/core/rxjs-interop";
import { APIService } from "../api";
import { tap } from "rxjs";

@Injectable()
export class GroupService {
    apiService = inject(APIService);
    usersService = inject(UsersService);

    // an alias to usersService
    membersGroups$ = this.usersService.membersGroups$;

    // all group permissions, used in admin group permissions page. for instance: 
    // view_building, edit_investment, etc.
    allGroupPermissions$ = toSignal(this.apiService.group_permissions().pipe(tap((permissions) => console.log("Permissions:", permissions))), { initialValue: [] });

}